import { createSelector } from 'reselect';

// Selettore di tempo mancante alla data di inizio
export const selectElapsedTime = createSelector(
  [(now: Date) => now, (_, dataInizio: string) => dataInizio],
  (now, dataInizio: string) => {
    if (now && dataInizio) {
      // Calcolare la differenza in millisecondi tra la data di inizio e la data corrente
      // const differenceInMilliseconds = new Date(dataInizio).getTime() - now?.getTime();
      const differenceSeconds = (new Date(dataInizio).getTime() - now.getTime()) / 1000;
      // calcolo la differenzaInMinuti
      const differenceMinutes = Math.floor(differenceSeconds / 60);
      // calcolo i secondi rimanenti
      const remainingSeconds = Math.floor(differenceSeconds % 60);
      // Se la differenza è maggiore di 180 secondi, restituire 0
      return differenceSeconds <= 180
        ? { elapsedTime: differenceSeconds, minutes: differenceMinutes, seconds: remainingSeconds }
        : { elapsedTime: 0, minutes: 0, seconds: 0 };
    }
    return { elapsedTime: undefined, minutes: 0, seconds: 0 };
  }
);
